/* ───────────────────────────────────────────────────────────
   Dialogue, Hero Collection product data
   Content sourced from the live dialogueskincare.com PDPs,
   lightly tightened. One object per SKU; the PDP renders
   any of them. Prices in GBP.
   ─────────────────────────────────────────────────────────── */

window.DIALOGUE_PRODUCTS = {

  /* ════════════════ LEO ════════════════ */
  leo: {
    id: 'leo',
    handle: 'leo-radiance-cleansing-balm-mask', // Shopify product handle (/products/<handle>)
    step: '01',
    sign: 'Leo',
    element: 'Fire',
    ruler: 'The Sun',
    season: 'Midsummer',
    energy: 'Confidence',
    intention: 'Radiance',
    glyph: 'https://www.dialogueskincare.com/cdn/shop/files/leo.svg',
    mark: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/leo-mark.svg?v=1781765200',

    name: 'Leo Radiance Cleansing Balm',
    name2: '& Mask',
    sub: 'Baume Nettoyant Éclat Leo',
    eyebrow: 'Leo · Fire · Sun-ruled',
    moods: ['Bold', 'Luminous', 'Unapologetic'],
    kind: 'Cleansing balm & mask',
    price: 48,
    size: '90ml',
    naturalLine: '100% natural origin · 73.8% certified organic',

    lede: 'A honey-like balm that melts make-up, SPF and the day away, then doubles as a 20-minute nourishing mask. Powered by a high dose of astaxanthin to brighten, protect and leave skin soft, supple and radiant.',

    proofStat: '85%',
    proofClaim: 'reported improved skin texture in 28 days',

    chips: ['Astaxanthin-rich', 'Balm-to-milk', 'Cleanse + mask', 'Cold-pressed oils', '100% natural'],

    benefits: [
      'Melts away make-up, SPF and daily impurities, no double cleanse needed',
      'Antioxidant astaxanthin helps shield and strengthen the skin barrier',
      'Doubles as a 20-minute nourishing mask for a deeper ritual',
      'Cold-pressed botanical oils leave skin soft, supple and comfortable',
      '100% ingredients of natural origin · 73.8% certified organic',
    ],

    results: [
      { pct: '100%', text: 'agreed the balm gently cleanses, effectively removing impurities and excess sebum' },
      { pct: '90%', text: 'experienced skin nourishment and regeneration when used as a mask' },
      { pct: '85%', text: 'reported improved skin texture, soft, smooth and firm after 28 days' },
      { pct: '80%', text: 'agreed the mask adds radiance even to dry and demanding skin' },
    ],
    studyNote: 'Consumer perception study, 20 participants, balm used as directed over 28 days. Individual results may vary.',

    heroIngredients: [
      { n: '01', name: 'Astaxanthin', tag: 'Solar shield', text: 'A potent antioxidant derived from algae, often called the “queen of antioxidants”. Helps protect skin from environmental stress while supporting hydration and a smoother appearance.' },
      { n: '02', name: 'Cold-Pressed Botanical Oils', tag: 'Cold-pressed · Certified', text: 'A certified blend of safflower, cherry kernel, passion fruit and apricot kernel oils. Rich in vitamins and fatty acids, they gently melt impurities and soften the complexion.' },
      { n: '03', name: 'Milk Thistle Seed Esters', tag: 'Renewable · Conscious', text: 'Sourced from renewable European crops. Nourishes, softens and conditions skin while giving the balm its signature honey-like texture.' },
    ],
    formulaLine: 'Formulated with 100% natural-origin ingredients, a balm-to-milk cleanse that doubles as a 20-minute nourishing mask, gentle yet effective on all skin types.',
    pullQuote: 'Surrender to the ritual. Let the balm melt away what the day left behind.',

    energyWords: ['Bold.', 'Luminous.', 'Unapologetic.'],
    energyBody: 'Leo energy is solar, radiant and fully alive. The Sun-ruled sign asks us to show up without apology, glowing, present, confident. This cleanse channels that fire: warming, clarifying, transformative. Use it as an act of self-assertion. A daily declaration that you are ready.',

    forWho: 'nourishment',
    concerns: [
      'Stubborn make-up, SPF and daily impurities',
      'Dryness or tightness after cleansing',
      'Dull, congested or tired-looking skin',
      'Skin in need of nourishment and ritual',
      'Anyone seeking a 2-in-1 cleanse and mask',
    ],
    skinProfile: [
      ['Skin type', 'All types'], ['Best for', 'Dry, mature'], ['Use', 'AM & PM'],
      ['First results', 'From first use'], ['Full results', 'By week 4'], ['Texture', 'Honey-like balm'],
    ],

    steps: [
      { n: '01', t: 'Scoop', d: 'Take a small amount with the spatula. Warm between fingertips until the balm softens.' },
      { n: '02', t: 'Massage', d: 'Apply to dry skin and massage in slow, upward circles for around 60 seconds.' },
      { n: '03', t: 'Emulsify', d: 'Add a little warm water and keep massaging as the balm turns into a milky cleansing cream.' },
      { n: '04', t: 'Rinse', d: 'Remove with a warm damp cloth. Use morning and evening as your opening ritual.' },
    ],
    ritualUpgrade: {
      title: 'Use as a nourishing mask',
      text: 'Apply a generous layer to clean, dry skin and leave for 20 minutes, 2 to 3 times a week. Rinse with warm water, 90% of participants experienced nourishment and regeneration when used this way.',
    },

    inci: 'Helianthus Annuus (Sunflower) Seed Oil, Glycerin, Caprylic/Capric Triglyceride, Tripelargonin, Aqua / Water, Cetearyl Glucoside, Sucrose Laurate, Prunus Cerasus (Bitter Cherry) Seed Oil, Carthamus Tinctorius (Safflower) Seed Oil, Prunus Armeniaca (Apricot) Kernel Oil, Passiflora Edulis Seed Oil, Sorbitan Olivate, Astaxanthin, Haematococcus Pluvialis Extract, Olea Europaea (Olive) Fruit Oil, Tocopherol, Sucrose Stearate, Cetearyl Alcohol, Parfum / Fragrance, Limonene, Linalool, Citral, Beta-Caryophyllene, Citronellol, Citrus Aurantium (Orange) Peel Oil, Citrus Limon (Lemon) Peel Oil, Geraniol, Geranyl Acetate, Juniperus Virginiana Oil, Lavandula Oil/Extract, Linalyl Acetate, Pelargonium Graveolens Flower Oil, Pinene, Pogostemon Cablin Oil, Terpineol, Terpinolene.',
    natPct: '100',

    gallery: [
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/product-leo-balm_c1c76a32-174c-4209-ae16-de8119f1bcfa.jpg?v=1781788365', label: 'Leo Radiance Cleansing Balm · 90ml' },
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/sunset-ocean_46891c9e-31fa-4fbe-bfa5-bf61af65f339.jpg?v=1781788367', label: 'Midsummer sun · Leo' },
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/portrait-skincare_7fcd60b9-95c9-40e0-900f-59eda4766720.jpg?v=1781788376', label: 'The ritual' },
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/texture-plaster-white.jpg?v=1781788392', label: 'Texture · honey-like balm' },
    ],
    energyImage: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/sunset-ocean_46891c9e-31fa-4fbe-bfa5-bf61af65f339.jpg?v=1781788367',

    reviews: [
      { name: 'Ashling Creedon', title: 'It left my skin glowing', body: 'Beautiful cleansing balm. It smells amazing, the texture is really luxurious and it left my skin glowing.' },
      { name: 'Aoife Forde', title: 'Easily my favourite cleanser', body: 'Super gentle but still gets my skin perfectly clean without that dry, tight feeling. My skin feels soft, balanced and really healthy after, and my complexion looks smoother and clearer. A staple in my routine now.' },
      { name: 'Sarah Mahon', title: 'Soft, light and beautifully scented', body: 'The cleansing balm melts beautifully into the skin and leaves my face feeling so clean and nourished. The scent makes my routine feel like such a treat every day.' },
    ],
  },


  /* ════════════════ AQUARIUS ════════════════ */
  aquarius: {
    id: 'aquarius',
    handle: 'aquarius-peptide-renewal-serum', // Shopify product handle (/products/<handle>)
    step: '02',
    sign: 'Aquarius',
    element: 'Air',
    ruler: 'Uranus',
    season: 'Midwinter',
    energy: 'Innovation',
    intention: 'Renewal',
    glyph: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/aquarius.svg?v=1781863968',
    mark: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/aquarius-mark.svg?v=1781863968',

    name: 'Aquarius Peptide Renewal Serum',
    name2: '',
    sub: 'Sérum Rénovateur aux Peptides Aquarius',
    eyebrow: 'Aquarius · Air · Uranus-ruled',
    moods: ['Innovative', 'Visionary', 'Clarity-first'],
    kind: 'Peptide renewal serum',
    price: 60,
    size: '30ml',
    naturalLine: '99% natural origin · certified organic',

    lede: 'A lightweight, fast-absorbing serum powered by copper tripeptide. It works deep to support collagen, visibly soften fine lines and restore a firm, dewy, future-facing glow, with a digital shield against screens and urban stress.',

    proofStat: '96%',
    proofClaim: 'reported intense moisturisation in 28 days',

    chips: ['Copper peptide', 'Fermented botanicals', 'Digital shield', 'Lightweight', 'Fast-absorbing'],

    benefits: [
      'Visibly reduces the appearance of fine lines',
      'Supports collagen for firmer, more resilient skin',
      'Strengthens the barrier, promoting elasticity and smoothness',
      'Hydrates and plumps for a dewy, youthful glow',
      '99.9% natural ingredients · 98/100 score on the Yuka app',
    ],

    results: [
      { pct: '96%', text: 'reported intense moisturisation, leaving skin soft and smooth to the touch' },
      { pct: '88%', text: 'observed improved overall skin condition and supported regeneration' },
      { pct: '84%', text: 'noticed improved elasticity and a reduction in the appearance of fine lines' },
      { pct: '80%', text: 'reported a reduction in skin roughness, with no adverse effects' },
    ],
    studyNote: 'Consumer perception study, 25 participants, serum used as directed over 28 days. Individual results may vary.',

    heroIngredients: [
      { n: '01', name: 'Copper Tripeptide', tag: 'Aquarius · Innovator', text: 'A well-researched active studied for its role in supporting skin regeneration. Helps support collagen and elastin, restore resilience and contribute to a luminous, healthy-looking complexion.' },
      { n: '02', name: 'Fermented Pea Extract', tag: 'Digital shield · Adaptive', text: 'A fermented extract that helps defend skin against the visible effects of environmental stress, pollution and electromagnetic exposure. Future-facing protection for an always-on world.' },
      { n: '03', name: 'Marine Algae & Mineral Complex', tag: 'Aquarian · Deep water', text: 'An advanced blend of algae and marine minerals delivering immediate hydration. Light, energising and restorative, hydration that breathes without weighing skin down.' },
    ],
    formulaLine: 'Formulated with a high-performance concentration of copper tripeptide, an active chosen for its well-documented role in supporting skin renewal and resilience.',
    pullQuote: 'Clear skin. Clear mind. Innovation in every drop.',

    energyWords: ['Innovative.', 'Visionary.', 'Ahead of its time.'],
    energyBody: 'Aquarius energy is electric, forward-thinking and free. The air sign that dares to reimagine what is possible, never bound by convention, always ahead of the curve. This serum channels that visionary frequency: protective, clarifying, quietly revolutionary. A daily commitment to skin that thinks for itself.',

    forWho: 'renewal',
    concerns: [
      'Fine lines and early signs of ageing',
      'Loss of elasticity and firmness',
      'Dull, tired or stressed skin',
      'Dehydration and lack of radiance',
      'Skin exposed to screens and urban pollution',
    ],
    skinProfile: [
      ['Skin type', 'All types'], ['Best for', 'Dry, mature'], ['Use', 'AM & PM'],
      ['First results', 'From week 1'], ['Full results', 'By week 4'], ['Texture', 'Lightweight'],
    ],

    steps: [
      { n: '01', t: 'Cleanse', d: 'Apply after the Leo Radiance Cleansing Balm on clean, slightly damp skin.' },
      { n: '02', t: 'Pump', d: 'Dispense 2 to 3 pumps into your palm. The lightweight formula feels almost weightless.' },
      { n: '03', t: 'Press', d: 'Press gently into skin with upward motions. Don’t rub, let it fully absorb.' },
      { n: '04', t: 'Seal', d: 'Follow with the Pisces Hydrating Facial Cream to lock in the actives and seal the ritual.' },
    ],
    ritualUpgrade: {
      title: 'What to expect',
      text: 'Week 1, skin feels immediately softer, the texture absorbs in seconds with no residue. Week 4, skin appears more radiant and firmer; in our 28-day study, 84% noticed improved elasticity.',
    },

    inci: 'Aqua / Water, Pentylene Glycol, Glycerin, Tamarindus Indica Seed Polysaccharide, Phenethyl Alcohol, Calcium Ketogluconate, Bis(Tripeptide-1) Copper Acetate, Marrubium Vulgare Extract, Chondrus Crispus Powder, Hydrolyzed Algin, Maris Aqua / Sea Water, Chlorella Vulgaris Extract, Hydrolyzed Pea Protein, Lonicera Caprifolium (Honeysuckle) Flower Extract, Lonicera Japonica (Honeysuckle) Flower Extract, Rosa Damascena Flower Oil, Rosa Damascena Flower Water, Lactic Acid, Glucose, Citric Acid, Sodium Succinate, Sodium Chloride.',
    natPct: '99',

    gallery: [
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/product-aquarius-serum_80c1f08a-e72d-4dce-8c04-7f4e24105dd1.jpg?v=1781864047', label: 'Aquarius Peptide Renewal Serum · 30ml' },
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/hero-moon-sky.png?v=1781864048', label: 'Midwinter air · Aquarius' },
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/portrait-ocean_90562a7c-b666-476f-8e25-24d1f586c036.jpg?v=1781864057', label: 'The ritual' },
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/pool-crystals_b83a3412-28c1-4832-9200-c8849efb3e3f.jpg?v=1781863619', label: 'Texture · weightless' },
    ],
    energyImage: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/hero-moon-sky.png?v=1781864048',

    reviews: [
      { name: 'Sorcha Dunphy', title: 'A real standout', body: 'The serum is a real standout for me. It’s soft, smooth and feels so luxurious on my skin. I have very sensitive skin and have to be cautious, but there was no irritation at all, just calm, glowing skin.' },
      { name: 'Anne Marie Dillon', title: 'My skin is glowing', body: 'I got the cleansing balm, the Aquarius serum and the Pisces cream, they are all just amazing. The serum and cream feel so luxurious. My skin is glowing, energised and feels very hydrated.' },
      { name: 'Sarah', title: 'Gentle and effective', body: 'Really lovely serum and moisturiser, both gentle and effective. I purchased because my previous products had been plaguing my very sensitive skin, I’ve just ordered more on the back of my first purchase.' },
    ],
  },

  

  

  /* ════════════════ PISCES ════════════════ */
  pisces: {
    id: 'pisces',
    handle: 'pisces-hydrating-facial-cream', // Shopify product handle (/products/<handle>)
    step: '03',
    sign: 'Pisces',
    element: 'Water',
    ruler: 'Neptune',
    season: 'Late winter',
    energy: 'Surrender',
    intention: 'Nourishment',
    glyph: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/pisces.svg?v=1781863536',
    mark: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/pisces-mark.svg?v=1781863536',

    name: 'Pisces Hydrating Facial Cream',
    name2: '',
    sub: 'Crème Hydratante pour le Visage Pisces',
    eyebrow: 'Pisces · Water · Neptune-ruled',
    moods: ['Fluid', 'Intuitive', 'Deeply nourishing'],
    kind: 'Hydrating facial cream',
    price: 55,
    size: '50ml',
    naturalLine: '99.8% natural origin · 100% botanical',

    lede: 'A nurturing cream that soothes, replenishes and dissolves dryness, restoring skin to a state of nourished calm and flow. A 100% botanical formulation with multi-weight hyaluronic, squalane and Allanblackia butter. Deeply hydrated, soothed, and held.',

    proofStat: '100%',
    proofClaim: 'reported better-hydrated skin after 7 days',

    chips: ['Multi-weight hyaluronic', 'Marine actives', 'Barrier-sealing', 'Calming complex', '100% botanical'],

    benefits: [
      'Five-weight hyaluronic complex for deep, lasting hydration at every layer',
      'Soothes and calms sensitive, reactive skin',
      'Squalane and botanical butters seal the moisture barrier',
      'Rich yet lightweight, melts in with no heaviness or residue',
      '99% ingredients of natural origin · 100% botanical formulation',
    ],

    results: [
      { pct: '100%', text: 'confirmed skin was better hydrated and less prone to dryness after 7 days' },
      { pct: '95%', text: 'reported a visible regeneration effect after 28 days of regular use' },
      { pct: '95%', text: 'noticed an overall improvement in facial skin condition over 28 days' },
      { pct: '90%', text: 'observed smoother, softer, more even skin texture' },
    ],
    studyNote: 'Consumer perception study, 20 participants, cream used as directed over 28 days. Individual results may vary.',

    heroIngredients: [
      { n: '01', name: 'Multi-Weight Hyaluronic Complex', tag: 'Pisces · Deep water', text: 'A blend of five hydrating actives, sodium hyaluronate, crosspolymer, hydrolyzed hyaluronic acid, hyaluronic acid and hydrolyzed glycosaminoglycans, for deep, lasting hydration across the skin’s layers.' },
      { n: '02', name: 'Red Macroalgae Extract', tag: 'Soothing · Protective', text: 'A certified extract of red macroalgae (Porphyra Umbilicalis), studied for its supportive role in skin comfort. Helps soothe and condition sensitive skin for a softer, more even feel.' },
      { n: '03', name: 'Squalane & Botanical Butters', tag: 'Organic · Barrier-sealing', text: 'A luxurious blend of squalane, shea, Allanblackia seed butter and jojoba. Lightweight yet richly nourishing, seals in moisture and conditions without heaviness.' },
    ],
    formulaLine: 'Formulated with a multi-weight hyaluronic acid complex, five hydrating actives chosen for their well-documented role in supporting deep, lasting moisture at every layer of the skin.',
    pullQuote: 'Release. Restore. Let your skin drink deeply.',

    energyWords: ['Fluid.', 'Intuitive.', 'Deeply nourishing.'],
    energyBody: 'Pisces energy is oceanic, boundless and deeply feeling. The water sign that dissolves boundaries and invites total surrender, to rest, to softness, to being held. This cream channels that depth: enveloping, restorative, profoundly nourishing. Apply it as a release. A signal to your nervous system that the day is complete.',

    forWho: 'deep hydration',
    concerns: [
      'Dry, dehydrated or thirsty skin',
      'Sensitive or reactive skin in need of calming',
      'A compromised or weakened moisture barrier',
      'Skin that feels tight after cleansing',
      'Anyone seeking lasting, lightweight hydration',
    ],
    skinProfile: [
      ['Skin type', 'All types'], ['Best for', 'Dry, sensitive'], ['Use', 'AM & PM'],
      ['First results', 'From first use'], ['Full results', 'By week 4'], ['Texture', 'Rich, lightweight'],
    ],

    steps: [
      { n: '01', t: 'Prep', d: 'Apply after your Aquarius Peptide Renewal Serum while skin is still slightly tacky.' },
      { n: '02', t: 'Warm', d: 'Take a pea-sized amount and warm between fingertips until it softens.' },
      { n: '03', t: 'Press', d: 'Press gently into skin from the centre of the face, working outward and upward.' },
      { n: '04', t: 'Surrender', d: 'Let it sink in, no rubbing needed. Use morning and evening as the closing act of your ritual.' },
    ],
    ritualUpgrade: {
      title: 'What to expect',
      text: 'Week 1, skin feels immediately softer and less tight; 100% reported better-hydrated skin after 7 days. Week 4, more radiant and deeply nourished; 95% reported a visible regeneration effect.',
    },

    inci: 'Aqua / Water, Shea Butter Ethyl Esters, Allanblackia Stuhlmannii Seed Butter, Helianthus Annuus (Sunflower) Seed Oil, Propanediol, Squalane, Pentylene Glycol, Silybum Marianum Seed Oil, Cetearyl Alcohol, Pouteria Sapota Seed Butter, Glycerin, C10-18 Triglycerides, Simmondsia Chinensis (Jojoba) Seed Oil, Nannochloropsis Oculata Extract, Porphyra Umbilicalis Extract, Sodium Hyaluronate, Sodium Hyaluronate Crosspolymer, Hydrolyzed Hyaluronic Acid, Hyaluronic Acid, Hydrolyzed Glycosaminoglycans, Sodium Levulinate, Tocopherol, Rhus Succedanea Fruit Cera, Copernicia Cerifera (Carnauba) Wax, Butyrospermum Parkii (Shea) Butter, Butyrospermum Parkii (Shea) Butter Unsaponifiables, Helianthus Annuus (Sunflower) Seed Wax, Glyceryl Stearate, Inulin Lauryl Carbamate, Jojoba Esters, Xanthan Gum, Soybean Glycerides, Sodium Stearoyl Glutamate, Polyglycerin-3, Sodium Anisate, Sodium Phytate, Lactic Acid, Ascorbyl Palmitate, Raspberry Ketone, Ethylhexylglycerin, Benzyl Glycol, Parfum / Fragrance, Cedrus Atlantica Oil/Extract, Citral, Citronellol, Citrus Aurantium Bergamia (Bergamot) Peel Oil, Citrus Aurantium (Orange) Peel Oil, Citrus Limon (Lemon) Peel Oil, Eucalyptus Globulus Oil, Geraniol, Geranyl Acetate, Limonene, Linalool, Linalyl Acetate, Pinene, Terpineol.',
    natPct: '99',

    gallery: [
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/product-pisces-cream-real_ea91140e-f0e6-4157-a81e-3af172305448.jpg?v=1781863589', label: 'Pisces Hydrating Facial Cream · 50ml' },
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/pool-glass_5831bc30-27f6-49e3-bef2-0f9f1c851477.jpg?v=1781863604', label: 'Late-winter water · Pisces' },
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/portrait-flower.jpg?v=1781863611', label: 'The ritual' },
      { src: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/pool-crystals_b83a3412-28c1-4832-9200-c8849efb3e3f.jpg?v=1781863619', label: 'Texture · rich, lightweight' },
    ],
    energyImage: 'https://cdn.shopify.com/s/files/1/1005/8127/7960/files/pool-glass_5831bc30-27f6-49e3-bef2-0f9f1c851477.jpg?v=1781863604',

    reviews: [
      { name: 'Siwan Griffiths', title: 'Obsessed', body: 'Obsessed with the Pisces hydrating facial cream. Feels so nourishing and hydrating.' },
      { name: 'Sorcha Dunphy', title: 'Calm and glowing skin', body: 'The moisturiser leaves my skin feeling deeply hydrated without being too heavy or greasy. I have very sensitive skin but had no irritation at all, just calm, glowing skin. You can tell so much thought has gone into every detail.' },
      { name: 'Shauna Courtney', title: 'The best skincare', body: 'The best skincare. Really worked on my sensitive skin and was delivered super quick.' },
    ],
  },
};

window.DIALOGUE_ORDER = ['pisces', 'aquarius', 'leo'];

/* The "Add the ritual to bag" CTA adds this bundle product to the cart. */
window.DIALOGUE_BUNDLE = { handle: 'ritual-bundle' };